<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>
<!--Header Imported -->
<app-header></app-header>
<!-- Section Begins -->
<section class="dashboard_container">
    <!-- Search Suplier Code Begin -->
    <div class="col-md-8 mtop25">
        <div class="row bgWhiteSomke" *ngIf="userRoleID != 1">
            <div class="col-md-7 mt15">&nbsp;</div>
            <div class="col-md-5 selectSupplier">
                <ng-multiselect-dropdown  [(ngModel)]="selectedItems" [settings]="dropdownSettings" [data]="dropdownList"
                    (onSelect)="onItemSelect($event)" (onDeSelect)="OnItemDeSelect($event)" (onSelectAll)="onSelectAll($event)"
                    (onDeSelectAll)="onDeSelectAll($event)">
                </ng-multiselect-dropdown>
            </div>
        </div>
    </div>
    <!-- Search Suplier Code End -->

    <!-- KPI Chart Begin -->
    <div class="col-md-12 mt15">
        <div class="row">
        <div class="col-md-6" style="margin-bottom: 2%;">
            <div class="card">
                <div class="card-header bgWhite">
                    <b class="card-title">{{ 'Ratio of Standard vs Non-standard Packaging' | translate}}</b>
                </div>
                <div class="card-body" style="height: 306px!important;">
                    <div class="row">   
                    <div class="col-md-6">
                        <div style="display: block" *ngIf="packageRatioStandardNonStandardPackageCodeChartsList.ratioStandardNonStandardPackageCodeData.length > 0">
                            <canvas style="border: 1px solid ghostwhite!important;
                            height: 25vh!important;
                            display: block!important;
                            width: 301px!important;
                            padding: 10px!important;"
                                baseChart [datasets]="packageRatioStandardNonStandardPackageCodeChartsList.ratioStandardNonStandardPackageCodeData"
                                [labels]="packageRatioStandardNonStandardPackageCodeChartsList.ratioStandardNonStandardPackageCodeLabels"
                                [options]="packageRatioStandardNonStandardPackageCodeChartsList.ratioStandardNonStandardPackageCodeOptions"
                                [legend]="packageRatioStandardNonStandardPackageCodeChartsList.ratioStandardNonStandardPackageCodeLegend"
                                [chartType]="packageRatioStandardNonStandardPackageCodeChartsList.ratioStandardNonStandardPackageCodeType"
                                [colors]="packageRatioStandardNonStandardPackageCodeChartsList.ratioStandardNonStandardPackageCodeColors"
                                (chartHover)="chartHovered($event)" (chartClick)="chartClicked($event)"></canvas>
                        </div>
                    </div>
                    <div class="col-md-6" style="padding-left: 5px;">
                        <div style="display: block" *ngIf="packageRatioStandardNonStandardChartsList.ratioStandardNonStandardData.length > 0">
                            <canvas style="border: 1px solid ghostwhite!important;
                            height: 285px!important;
                            display: block!important;
                            width: 301px!important;
                            padding: 10px!important;"
                                baseChart [datasets]="packageRatioStandardNonStandardChartsList.ratioStandardNonStandardData"
                                [labels]="packageRatioStandardNonStandardChartsList.ratioStandardNonStandardLabels"
                                [options]="packageRatioStandardNonStandardChartsList.ratioStandardNonStandardOptions"
                                [legend]="packageRatioStandardNonStandardChartsList.ratioStandardNonStandardLegend"
                                [chartType]="packageRatioStandardNonStandardChartsList.ratioStandardNonStandardType"
                                [colors]="packageRatioStandardNonStandardChartsList.ratioStandardNonStandardColors"
                                (chartHover)="chartHovered($event)" (chartClick)="chartClicked($event)"></canvas>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-6">
            <div class="card">
                <div class="card-header bgWhite">
                    <b class="card-title">{{ 'Development of standard package ratio' | translate}}</b>
                </div>
                <div class="card-body" style="height: 306px!important;">
                    <div style="display: block; height: 25vh;" *ngIf="packageRatioChartsList.packageRatioChartData.length > 0">
                        <canvas baseChart [datasets]="packageRatioChartsList.packageRatioChartData" [labels]="packageRatioChartsList.packageRatioChartLabels"
                            [options]="packageRatioChartsList.packageRatioChartOptions" [legend]="packageRatioChartsList.packageRatioChartLegend"
                            [chartType]="packageRatioChartsList.packageRatioChartType" [colors]="packageRatioChartsList.packageRatiochartColors"
                            (chartHover)="chartHovered($event)" (chartClick)="chartClicked($event)"></canvas>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>

    <div class="col-md-12 bgWhiteSomke">
        <div class="row">
        <div class="col-md-6">
            <div class=" card">
                <div class="card-headerbgWhite">
                    <b class="card-title">{{ 'Status of Active packaging Request' | translate}}</b>
                </div>
                <div class="card-body" style="height: 306px!important;">
                    <div class="row">
                    <div class="col-md-6" style="padding-left: 0px;">
                        <div style="display: block" *ngIf="packageStatusUnderReviewActiveRejectedNonCatChartsList.packageUnderReviewActiveRejectedNonCatChartData.length > 0">
                            <canvas style="border: 1px solid ghostwhite!important;
                            height: 285px!important;
                            display: block!important;
                            width: 301px!important;
                            padding: 10px!important;"
                                baseChart [datasets]="packageStatusUnderReviewActiveRejectedNonCatChartsList.packageUnderReviewActiveRejectedNonCatChartData"
                                [labels]="packageStatusUnderReviewActiveRejectedNonCatChartsList.packageUnderReviewActiveRejectedNonCatChartLabels"
                                [options]="packageStatusUnderReviewActiveRejectedNonCatChartsList.packageUnderReviewActiveRejectedNonCatChartOptions"
                                [legend]="packageStatusUnderReviewActiveRejectedNonCatChartsList.packageUnderReviewActiveRejectedNonCatChartLegend"
                                [chartType]="packageStatusUnderReviewActiveRejectedNonCatChartsList.packageUnderReviewActiveRejectedNonCatChartType"
                                [colors]="packageStatusUnderReviewActiveRejectedNonCatChartsList.packageUnderReviewActiveRejectedNonCatchartColors"
                                (chartHover)="chartHovered($event)" (chartClick)="chartClicked($event)"></canvas>
                        </div>
                    </div>
                    <div class="col-md-6" style="padding-left: 5px;">
                        <div style="display: block" *ngIf="packageStatusUnderReviewActiveRejectedChartsList.packageUnderReviewActiveRejectedChartData.length > 0">
                            <canvas style="border: 1px solid ghostwhite!important;
                                height: 285px!important;
                                display: block!important;
                                width: 281px!important;
                                padding: 10px!important;"
                                baseChart [datasets]="packageStatusUnderReviewActiveRejectedChartsList.packageUnderReviewActiveRejectedChartData"
                                [labels]="packageStatusUnderReviewActiveRejectedChartsList.packageUnderReviewActiveRejectedChartLabels"
                                [options]="packageStatusUnderReviewActiveRejectedChartsList.packageUnderReviewActiveRejectedChartOptions"
                                [legend]="packageStatusUnderReviewActiveRejectedChartsList.packageUnderReviewActiveRejectedChartLegend"
                                [chartType]="packageStatusUnderReviewActiveRejectedChartsList.packageUnderReviewActiveRejectedChartType"
                                [colors]="packageStatusUnderReviewActiveRejectedChartsList.packageUnderReviewActiveRejectedchartColors"
                                (chartHover)="chartHovered($event)" (chartClick)="chartClicked($event)"></canvas>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-6">
            <div class="card">
                <div class="card-header bgWhite">
                    <b class="card-title">{{ '# of Parts with lot size ≠ Packaging Size' | translate}}</b>
                </div>
                <div class="card-body" style="height: 306px!important;">
                    <div style="display: block;height: 25vh;" *ngIf="packageSizeChartsList.packageSizeChartData.length > 0">
                        <canvas baseChart [datasets]="packageSizeChartsList.packageSizeChartData" [labels]="packageSizeChartsList.packageSizeChartLabels"
                            [options]="packageSizeChartsList.packageSizeChartOptions" [legend]="packageSizeChartsList.packageSizeChartLegend"
                            [chartType]="packageSizeChartsList.packageSizeChartType" [colors]="packageSizeChartsList.packageSizechartColors"
                            (chartHover)="chartHovered($event)" (chartClick)="chartClicked($event)"></canvas>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
    <!-- KPI Chart End -->
</section>
<!-- Section End -->